(() => {
  if (customElements.get('slofe-shipping-progress')) return;
  let version = 0;
  let timer;
  let activeRequest;
  const instances = () => document.querySelectorAll('slofe-shipping-progress');
  const invalidate = () => {
    version += 1;
    activeRequest?.abort();
    clearTimeout(timer);
    instances().forEach((element) => { element.hidden = true; });
  };
  const refresh = () => {
    invalidate();
    const requestVersion = version;
    timer = setTimeout(async () => {
      const controller = new AbortController();
      activeRequest = controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const url = new URL(window.routes.cart_url, location.origin);
        url.searchParams.set('sections', 'slofe-shipping-progress');
        const response = await fetch(url, { signal: controller.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Shipping information unavailable');
        const sections = await response.json();
        const source = new DOMParser().parseFromString(sections['slofe-shipping-progress'] || '', 'text/html')
          .querySelector('slofe-shipping-progress');
        if (!source || requestVersion !== version) return;
        instances().forEach((element) => {
          element.innerHTML = source.innerHTML;
          for (const name of ['state', 'total', 'country', 'currency']) element.dataset[name] = source.dataset[name];
          element.hidden = source.hasAttribute('hidden');
        });
      } catch {
        if (requestVersion === version) instances().forEach((element) => { element.hidden = true; });
      } finally {
        clearTimeout(timeout);
        if (activeRequest === controller) activeRequest = null;
      }
    }, 80);
  };
  customElements.define('slofe-shipping-progress', class extends HTMLElement {
    connectedCallback() { refresh(); }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => { refresh(); });
    subscribe(PUB_SUB_EVENTS.cartError, () => { refresh(); });
  }
  document.addEventListener('submit', (event) => {
    const action = event.target.getAttribute?.('action') || '';
    if (/\/cart(?:\/add)?(?:\.js)?(?:\?|$)/.test(action) || action.includes('/localization')) invalidate();
  }, true);
  document.addEventListener('input', (event) => {
    if (event.target.matches('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]')) invalidate();
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('cart-remove-button')) invalidate();
  }, true);
  for (const name of ['cart:updated', 'cart:refresh', 'cart:change']) document.addEventListener(name, refresh);
  document.addEventListener('cart:lines-update', (event) => {
    invalidate();
    const pending = event.detail?.promise;
    if (pending && typeof pending.then === 'function') pending.then(refresh, refresh);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
})();
